import React from 'react';
import Icon from '.';

const CheckIcon = props => (
	<Icon {...props} viewBox="0 0 24 24">
		<path d="M0 0h24v24H0V0z" fill="none" />
		<path
			fill="currentColor"
			d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z"
		/>
	</Icon>
);

export default CheckIcon;
